module.exports = __webpack_public_path__ + "static/media/Add.eb59cb44.svg";